<template>
	<div>
		<div id="tb11" style="width: 100%;height: 350px;"></div>
		<div style="background-color: #0F0B26;color: white;display: flex;justify-content: space-between;margin-top: 20px;">
			<div>剩余车位</div>
			<div>使用率</div>
		</div>
		<div style="background-color: #0F0B26;color: white;display: flex;justify-content: space-between;">
			<div>A停车场总车位6000，剩余车位3000</div>
			<div>50%</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["rcxx", "isTrue"],
		data() {
			return {

			}
		},
		mounted() {
			this.getJrqk()
		},
		methods: {
			getJrqk() {
				let myChart = this.echarts.init(document.getElementById('tb11'), 'dark');
				setTimeout(() => {
					this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {
						let option = {
							backgroundColor: '#0F0B26',
							title: {
								text: '本月车流量'
							},
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow'
								}
							},
							color:['#00a8fb'],
							legend: {},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								type: 'value',
								boundaryGap: [0, 0.01]
							},
							yAxis: {
								type: 'category',
								data: ['00:00-05:59', '06:00-08:59', '09:00-11:59', '12:00-17:59', '18:00-20:59', '21:00-23:59']
							},
							series: [{
									
									type: 'bar',
									data: [18203, 23489, 29034, 104970, 131744, 630230]
								}
							]
						};
						myChart.setOption(option);
					})
				}, 100)
			}
		}
	}
</script>

<style scoped="scoped">
</style>
